import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TenantService } from '../../../../core/services/tenant.service';
import { Tenant } from '../../../../data/models';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';

@Component({
    selector: 'app-sidebar2-subpanel-tenants',
    templateUrl: './sidebar2-subpanel-tenants.component.html',
    styleUrls: ['./sidebar2-subpanel-tenants.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class Sidebar2SubpanelTenantsComponent implements OnInit, OnDestroy {
    // @ts-ignore TS2564
    @Input() dropDownClasses: string;
    dropdownOpen = false;
    // @ts-ignore TS2564
    rootTenant: Tenant;
    // @ts-ignore TS2564
    hierSubscription: Subscription;

    constructor(
        private tenantService: TenantService,
        private settings: RepoSettingsService
    ) {}

    ngOnInit(): void {
        this.hierSubscription = this.tenantService.getTenantHeirarchy().subscribe((r) => {
            this.rootTenant = r;
        });
        const open = this.settings.TenantHierarchyDropdown;
        if (!open) {
            return;
        }
        this.dropdownOpen = open;
    }

    headerLink() {
        this.dropdownOpen = !this.dropdownOpen;
        this.settings.TenantHierarchyDropdown = this.dropdownOpen;
    }

    ngOnDestroy(): void {
        if (this.hierSubscription) {
            this.hierSubscription.unsubscribe();
        }
    }
}
